module.exports = __webpack_public_path__ + "static/media/d0.933eb856.jpg";